// Lio issues, from the point of view of the person they were handed to.
//
// The QUEUE itself is the superadmin's and lives in src/api/superadmin.ts —
// a gap in Lio is TeamLio's problem, not a customer's, so no org admin has a
// view of it. What is here is the other half: what landed on *my* plate, and
// the bell rows that told me.
import api from "./api";

export type LioIssueStatus = "open" | "in_progress" | "resolved" | "dismissed";

/** One issue assigned to the signed-in user. Shaped by hrms
 *  `leo/issues.py::serialize`, minus nothing — the assignee sees the same row
 *  the superadmin does, because they are the one expected to fix it. */
export interface MyLioIssue {
  id: string;
  question: string;
  reply?: string | null;
  tool_used?: string | null;
  note?: string | null;
  status: LioIssueStatus;
  response?: string | null;
  reporter_name: string;
  reporter_role?: string | null;
  /** The customer org that hit it. */
  org_id?: string | null;
  org_name?: string | null;
  /** Everyone on it, me included. Always an array. */
  assignees: Array<{ user_id: string; name: string; assigned_at?: string | null }>;
  reviewed_by_name?: string | null;
  reviewed_at?: string | null;
  created_at?: string | null;
}

/** Issues handed to me. Self-only server-side, so it needs no panel. */
export const getMyAssignedLioIssues = async (): Promise<MyLioIssue[]> => {
  const { data } = await api.get("/leo/issues/assigned-to-me");
  return data?.issues || [];
};

// --- bell feed -------------------------------------------------------------
// Same contract as every other module's: the bell fans out across all of them
// and merges on `task_id`, which is namespaced "lio_issue:<issue_id>" here.

export interface LioIssueNotification {
  id: string;
  kind: string;
  source: "lio_issue";
  issue_id: string | null;
  task_id: string;
  title: string;
  body: string | null;
  is_read: boolean;
  created_at: string;
}

export const getLioIssueNotifications = (limit = 50) =>
  api.get<{ total: number; items: LioIssueNotification[] }>(
    `/leo/issues/notifications/unread?limit=${limit}`,
  );

export const markLioIssueNotificationRead = (id: string) =>
  api.post(`/leo/issues/notifications/${id}/read`);
